/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Boolean } from '../models/boolean';
import { fileControllerCreateAttachFile } from '../fn/file/file-controller-create-attach-file';
import { FileControllerCreateAttachFile$Params } from '../fn/file/file-controller-create-attach-file';
import { fileControllerDelete } from '../fn/file/file-controller-delete';
import { FileControllerDelete$Params } from '../fn/file/file-controller-delete';
import { fileControllerDeleteAttachFile } from '../fn/file/file-controller-delete-attach-file';
import { FileControllerDeleteAttachFile$Params } from '../fn/file/file-controller-delete-attach-file';
import { fileControllerDeleteMany } from '../fn/file/file-controller-delete-many';
import { FileControllerDeleteMany$Params } from '../fn/file/file-controller-delete-many';
import { fileControllerFindById } from '../fn/file/file-controller-find-by-id';
import { FileControllerFindById$Params } from '../fn/file/file-controller-find-by-id';
import { fileControllerFindByUrl } from '../fn/file/file-controller-find-by-url';
import { FileControllerFindByUrl$Params } from '../fn/file/file-controller-find-by-url';
import { fileControllerUpdateAttachFile } from '../fn/file/file-controller-update-attach-file';
import { FileControllerUpdateAttachFile$Params } from '../fn/file/file-controller-update-attach-file';
import { fileControllerUpload } from '../fn/file/file-controller-upload';
import { FileControllerUpload$Params } from '../fn/file/file-controller-upload';
import { FileDto } from '../models/file-dto';
import { UploadedFileDto } from '../models/uploaded-file-dto';

@Injectable({ providedIn: 'root' })
export class FileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fileControllerFindByUrl()` */
  static readonly FileControllerFindByUrlPath = '/api/v1/file/get/{url}';

  /**
   * 파일 조회.
   *
   * 파일을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerFindByUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerFindByUrl$Response(params: FileControllerFindByUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDto>> {
    return fileControllerFindByUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 조회.
   *
   * 파일을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerFindByUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerFindByUrl(params: FileControllerFindByUrl$Params, context?: HttpContext): Observable<FileDto> {
    return this.fileControllerFindByUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDto>): FileDto => r.body)
    );
  }

  /** Path part for operation `fileControllerFindById()` */
  static readonly FileControllerFindByIdPath = '/api/v1/file/{id}';

  /**
   * 파일 조회.
   *
   * 파일을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerFindById$Response(params: FileControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDto>> {
    return fileControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 조회.
   *
   * 파일을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerFindById(params: FileControllerFindById$Params, context?: HttpContext): Observable<FileDto> {
    return this.fileControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDto>): FileDto => r.body)
    );
  }

  /** Path part for operation `fileControllerUpload()` */
  static readonly FileControllerUploadPath = '/api/v1/file';

  /**
   * 파일 업로드.
   *
   * 파일을 업로드합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerUpload()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileControllerUpload$Response(params: FileControllerUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadedFileDto>> {
    return fileControllerUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 업로드.
   *
   * 파일을 업로드합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerUpload$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  fileControllerUpload(params: FileControllerUpload$Params, context?: HttpContext): Observable<UploadedFileDto> {
    return this.fileControllerUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadedFileDto>): UploadedFileDto => r.body)
    );
  }

  /** Path part for operation `fileControllerCreateAttachFile()` */
  static readonly FileControllerCreateAttachFilePath = '/api/v1/file/{userId}/attach-file';

  /**
   * 회원 첨부파일 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerCreateAttachFile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fileControllerCreateAttachFile$Response(params: FileControllerCreateAttachFile$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDto>> {
    return fileControllerCreateAttachFile(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 첨부파일 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerCreateAttachFile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fileControllerCreateAttachFile(params: FileControllerCreateAttachFile$Params, context?: HttpContext): Observable<FileDto> {
    return this.fileControllerCreateAttachFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDto>): FileDto => r.body)
    );
  }

  /** Path part for operation `fileControllerUpdateAttachFile()` */
  static readonly FileControllerUpdateAttachFilePath = '/api/v1/file/{userId}/{fileUrl}/attach-file';

  /**
   * 회원 첨부파일 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerUpdateAttachFile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fileControllerUpdateAttachFile$Response(params: FileControllerUpdateAttachFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Boolean>> {
    return fileControllerUpdateAttachFile(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 첨부파일 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerUpdateAttachFile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fileControllerUpdateAttachFile(params: FileControllerUpdateAttachFile$Params, context?: HttpContext): Observable<Boolean> {
    return this.fileControllerUpdateAttachFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Boolean>): Boolean => r.body)
    );
  }

  /** Path part for operation `fileControllerDeleteAttachFile()` */
  static readonly FileControllerDeleteAttachFilePath = '/api/v1/file/{userId}/{fileUrl}';

  /**
   * 회원 첨부파일 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerDeleteAttachFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerDeleteAttachFile$Response(params: FileControllerDeleteAttachFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Boolean>> {
    return fileControllerDeleteAttachFile(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 첨부파일 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerDeleteAttachFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerDeleteAttachFile(params: FileControllerDeleteAttachFile$Params, context?: HttpContext): Observable<Boolean> {
    return this.fileControllerDeleteAttachFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Boolean>): Boolean => r.body)
    );
  }

  /** Path part for operation `fileControllerDeleteMany()` */
  static readonly FileControllerDeleteManyPath = '/api/v1/file/delete-many';

  /**
   * 복수 파일 삭제.
   *
   * 1개 이상의 파일을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerDeleteMany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fileControllerDeleteMany$Response(params: FileControllerDeleteMany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileControllerDeleteMany(this.http, this.rootUrl, params, context);
  }

  /**
   * 복수 파일 삭제.
   *
   * 1개 이상의 파일을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerDeleteMany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fileControllerDeleteMany(params: FileControllerDeleteMany$Params, context?: HttpContext): Observable<void> {
    return this.fileControllerDeleteMany$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `fileControllerDelete()` */
  static readonly FileControllerDeletePath = '/api/v1/file/{url}';

  /**
   * 파일 삭제.
   *
   * 파일을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fileControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerDelete$Response(params: FileControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return fileControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 파일 삭제.
   *
   * 파일을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fileControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fileControllerDelete(params: FileControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.fileControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
